import { render } from "./CloneTemplate.vue?vue&type=template&id=0c80e554&scoped=true"
import script from "./CloneTemplate.vue?vue&type=script&lang=js"
export * from "./CloneTemplate.vue?vue&type=script&lang=js"

import "./CloneTemplate.vue?vue&type=style&index=0&id=0c80e554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c80e554"]])

export default __exports__